'use client';

import classNames from 'classnames';
import { LandingFeatures } from '@sapientpro/sapientpro-data-models/types/components/landing-page';
import { useAtomValue } from 'jotai';
import styles from './Features.module.scss';
import AnimatedTitle from '../../../components/AnimatedTitle';
import Case from './Case';
import { Theme, theme } from '../../../store/theme';
import { SUPPORTED_VIDEO_EXTENSIONS } from '../../../../constants';

const Features = ({
  data,
}: {
  data: LandingFeatures;
}) => {
  const appTheme = useAtomValue(theme);

  const isDarkMode = appTheme === Theme.DARK;

  return (
    <section className={classNames(styles.features, 'container')}>
      <h2 className={classNames(styles.features__title, 'header2')}>
        <AnimatedTitle title={data.title} />
      </h2>
      <div className={classNames(styles.features__content, {
        [styles.pairEven]: data.displayType === 'starts-with -pair',
        [styles.pairOdd]: data.displayType === 'starts-with-single',
      })}
      >
        {data.featuresList.map((item) => {
          const darkMedia = item.darkMedia || item.lightMedia;
          const media = isDarkMode ? darkMedia : item.lightMedia;
          const isVideo = SUPPORTED_VIDEO_EXTENSIONS.includes(media.ext);

          return (
            <Case
              key={item.id}
              caseData={{ ...item, [isVideo ? 'video' : 'image']: media }}
              classes={{
                case: styles.case,
                caseInfo: styles.case__caseInfo,
                caseMediaVideo: styles.case__caseMediaVideo,
                caseMediaImage: styles.case__caseMediaImage,
              }}
            />
          );
        })}
      </div>
    </section>
  );
};

export default Features;
